/**
 * The Library's INTRODUCTION shelf — guides to reading the Library itself.
 *
 * Not documents: a document is a folder of materials about one text, authored
 * in the block editor and stored in the database. A guide is about HOW every
 * text here is written, ships with the code, and is rendered offline in the
 * owner's own fonts (see SiksaGuide.tsx). So it is a small registry rather
 * than a document type, and the Library's Introduction tab lists this array.
 */
export interface Guide {
  slug: string;
  title: string;
  subtitle: string;
  blurb: string;
}

export const GUIDES: readonly Guide[] = [
  {
    slug: "siksa",
    title: "Śikṣā",
    subtitle: "the science of pronunciation",
    blurb:
      "Letters, pitch, duration, force, linking and pauses; the anusvāra and the visarga; and how our texts mark them — with examples from the Library's chants.",
  },
];

export function guideBySlug(slug: string | undefined): Guide | undefined {
  return GUIDES.find((g) => g.slug === slug);
}
